let names = {
  name: 'CARROCASH',
  domain: 'carrocash.com.br',
  protocol: 'http',
    // url: '192.168.15.13:8000',
    // fullUrl: 'http://192.168.15.13:8000/',
  url: 'api.carrocash.com.br',
  fullUrl: 'https://api.carrocash.com.br/',

  color: "#4f4f4f"
};
console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV === 'production') {
  names.domain = 'carrocash.com.br',
  names.protocol = 'https';
  names.url = 'api.carrocash.com.br';
  names.fullUrl = 'https://api.carrocash.com.br/';
} 

export const NAMES = names;


export const CookieDomain = ((process.env.NODE_ENV === 'production'))
  ? `.${names.domain}`
  : '';




// WEBPACK FOOTER //
// ./src/config.js